export default __webpack_public_path__ + "static/media/downloadFiles.a64feb04.svg";